/* Combobox remoto de compañias, filtra por usuario */
import { useLazyQuery } from "@apollo/client";
import { SelectProps } from "antd";
import { COMPANIES } from "./ComboboxGQL";
import RemoteComboBox from "../../../shared/RemoteComboBox";

interface CompaniesComboBoxProps extends SelectProps<string> {
    pageSize?: number;
    parentid?: string;
    user_id?: string;
}

const CompaniesComboBox: React.FC<CompaniesComboBoxProps> = ({
    pageSize = 7,
    parentid,
    user_id,
    ...props
}) => {
    const DEFAULT_VARIABLES = parentid ? {
        parentid,
    } : {
    };

    const [getData, { data, loading, error }] = useLazyQuery(
        COMPANIES,
        {
            fetchPolicy: "no-cache",
            variables: {
                ...DEFAULT_VARIABLES,
                search: "",
                combo: true,
                table: false,
                user_id,
            },
        }
    );

    return (
        <RemoteComboBox
            {...props}
            showSearch
            optionIdKey={"id"}
            optionValueKey={"name"}
            pageSize={pageSize}
            defaultVariables={DEFAULT_VARIABLES}
            fetchData={getData}
            data={data}
            optionFilterProp="children"
            dataKey={"companiesByUser"}
            loading={loading}
            error={error}
            addDropRender
        />
    );
};

export default CompaniesComboBox;
